import React from 'react';

const AccountSettings = {
  title: 'Account Settings',
  items: [
    {
      header: 'How can I become a Local Expert?',
      content: (
        <div>
          <p>Check <a href="https://www.takemetour.com/local-expert-benefits" target="_blank" rel="noopener noreferrer">the Local Expert benefits.</a> Then, click ‘Start Now’ and <a href="https://www.takemetour.com/dashboard/verification" target="_blank" rel="noopener noreferrer">complete the verification</a> process and start listing your trip with us!</p>
        </div>
      )
    },
    {
      header: 'How can I change my email address?',
      content: (
        <div>
          <p>You cannot change your registered email by yourself as it is used to log in to your account. If you would like to do so, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    },
    {
      header: 'How can I verify my identity?',
      content: (
        <div>
          <p>You can verify your identity on the <a href="https://www.takemetour.com/dashboard/verification" target="_blank" rel="noopener noreferrer">Verification</a> page by submitting the information/uploading your personal ID card, ID card with selfie, and bank account to us. It will take 2-3 business days to be approved.</p>
          <p>Criminal record check may take longer as it must be submitted to the government.</p>
        </div>
      )
    },
    {
      header: 'How do I update my bank book or ID card information?',
      content: (
        <div>
          <p>If you would like to update your information, please submit a solid reason to us at <a href="mailto:support@takemetour.com">support@takemetour.com.</a> We will contact you back via email within 1-2 business days for further process.</p>
        </div>
      )
    },
    {
      header: 'How can I reset my password?',
      content: (
        <div>
          <p>To reset your password, you can visit ‘Edit Your Profile’ and select ‘Settings’ to change your password. </p>
          <p>Your password should be a combination of uppercase letters, lowercase letters, and numbers. </p>
        </div>
      )
    },
    {
      header: 'What can I do if I forgot my password?',
      content: (
        <div>
          <p>If you forgot your password, please click ‘forgot your password’. A password reset email will be sent to your registered email immediately and you can change your password. </p>
          <p>If you still have difficulty logging in to your account, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com.</a> We will do our best to help you. </p>
        </div>
      )
    },
    {
      header: 'How can I deactivate my account?',
      content: (
        <div>
          <p>Referring to our <a href="../../static/files/help-center/TakeMeTour Privacy Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy and Terms of Use</a>, you can deactivate your account by <a href="../../static/files/help-center/GENERAL CONSENT WITHDRAWAL & DEACTIVATED ACCOUNT REQUEST FORM.pdf" target="_blank" rel="noopener noreferrer">submitting</a> this form and sending it to us at <a href="mailto:support@takemetour.com">support@takemetour.com.</a> Your account will be permanently deleted within 30 business days</p>
          <p>To delete you listed trip, please see ‘How do I delete my listed trip?’</p>
        </div>
      )
    },
    {
      header: 'What is criminal record?',
      content: (
        <div>
          <p>For safety and trust of travelers, criminal record is part of our screening process. Therefore, we advise you to submit a permission to conduct criminal record check. The process may take up to 30 business days. </p>
        </div>
      )
    }
  ]
};

export default AccountSettings;
